import { getDataMapper, mapField } from "@/shared";

export const mapPeriodToServer = getDataMapper({
    period_start: mapField("from"),
    period_end: mapField("to"),
});
